import { GetEpAgreementWallContextQuery } from '../../../graphql/queries/getEpAgreementWallContext.gql';
import { getIsAgreementDone } from './getIsAgreementDone';
import { getIsComplianceDone } from './getIsComplianceDone';
import { getIsRegistrationDateDone } from './getIsRegistrationDateDone';

export const getHasCompletedAllSteps = (
  moduleData: GetEpAgreementWallContextQuery,
) => {
  const isAgreementDone = getIsAgreementDone(moduleData);
  const isComplianceDone = getIsComplianceDone(moduleData);
  const isRegistrationDateDone = getIsRegistrationDateDone(moduleData);

  return isAgreementDone && isComplianceDone && isRegistrationDateDone;
};
